module.exports = __webpack_public_path__ + "img/collectactives.787d55ef.svg";